import React from 'react';
import css from './Contributors.module.css';
import { NamedLink } from '../../../../components';
import CollaboratorImage from '../../../../assets/colaboradora.png';
import CollaboratorImage2 from '../../../../assets/colaboradores2n.png';

const Contributors = ({}) => {
  return (
    <>
      <section className={`${css.section} ${css.infoSection}`}>
        <div className={css.infoContainer}>
          
          <div className={css.infoBody}>
            <div className={css.innerText}>

           
            <h2 className={css.sectionTitle}>COLABORADORES</h2>
            <p className={css.sectionSubtitle}>
            ¿Quieres colaborar con BioCerca?
            </p>
             {/* <h3 className={css.featureTitle}>¿Te has cansado de vender por debajo del coste? </h3> */}
           
            <p>Si tienes un proyecto, una tienda local, un canal de comunicación o simplemente ideas que conectan con lo que somos… hablemos.</p>
            {/* <p>¿De depender de cadenas que se quedan con casi todo… mientras tú solo sostienes la tierra?</p> */}
            <p>En BioCerca creemos en las alianzas reales, las que nacen de valores compartidos y ganas de construir algo mejor.</p>
            <p>Colaborar no es solo ayudar. Es crecer juntos.</p>
           <NamedLink
                    name="CollaboratorsPage"
                    style={{ backgroundColor: 'white', color: 'var(--colorBioCercaGreen)' }}
                   className={css.bottomText}>
                <button className={css.infoButton}>Inscríbete como colaborador</button>
          </NamedLink>
             
          </div>
           </div>
            <div className={css.infoImage}>
              <img src={CollaboratorImage2} alt="farming vegetables" />
          </div>
         
        </div>
       
      </section>
    </>
  );
};

export default Contributors;



